// "Push in" (owner 2026-10-31: "push in never really flies to the end point, it just starts to the direction of the
// selected point/place with 3 different speed settings"): a tour stop's move. The camera heads for the stop's pivot
// (`moveOptions.around`, else its place, else the middle of the view) and never arrives: each frame the camera AND
// the point it looks at move towards the pivot by the same share (the mouse wheel's zoom, smooth), so the pivot keeps
// its place in the picture and nothing turns. Never closer than the controls' zoom limit. At rest when the stay
// begins and ends (rig.js `ramp`). An old `gentle-drift` plays as this move (moves/index.js).
// moveOptions:
//   speed   `slow`, `medium`, `fast`: the share it closes in a second, 2.5 %, 5 % (default), 10 % (rig.js SPEED)
//   travel  seconds the flight takes (default 4, the old drift's: 0 = a cut)
// `pose` (VIS-265) is Film's push at a point and is read by the Film tests alone: the camera moves straight towards
// what it looks at, the share `close` of the distance (0..0.95, default 0.5; negative pulls back, down to -2).
import { easeInOut, ramp, speedOf } from './rig.js';

const MIN = 2; // metres: never closer to the point it looks at
const RATE = 0.05; // the share of the distance closed in a second at medium speed

/** @param {import('./rig.js').View} view  @param {number} k  0..1 of the move  @returns {import('./rig.js').View} */
export function pose(view, k, o = {}) {
  const close = Math.min(0.95, Math.max(-2, Number.isFinite(o.close) ? o.close : 0.5)), [p, t] = [view.position, view.target];
  const d = Math.hypot(p[0] - t[0], p[1] - t[1], p[2] - t[2]);
  if (!(d > MIN)) return view;
  const s = Math.max(MIN / d, 1 - close * easeInOut(Math.min(1, Math.max(0, k))));
  return { ...view, position: p.map((v, i) => t[i] + (v - t[i]) * s) };
}

export default function pushIn(o, rig) {
  const rate = RATE * speedOf(o);
  return {
    travel: Number.isFinite(o.travel) ? Math.max(0, o.travel) : 4,
    hold: false,
    step(dt, t, len) { rig.turn(0, Math.exp(-rate * ramp(t, len) * dt)); },
  };
}
